import { createSelector } from "@reduxjs/toolkit";

export const adminSignInState = (state) => state.adminSignIn;

export const adminSignInSelectors = createSelector(adminSignInState, (state) => state);
